export default __webpack_public_path__ + "static/media/slider3.02ae92b4.jpg";